import { MOCK_REMINDERS } from '../../mocks/messages';

const MessagesReminders = () => (
  <div className="space-y-4">
    <div>
      <h2 className="font-display text-2xl font-light text-ink-900">Automated reminders</h2>
      <p className="mt-1 text-sm text-ink-700/80">
        Confirmations, nudges and rebook prompts sent on WhatsApp once the account is connected.
      </p>
    </div>
    <ul className="divide-y divide-ink-900/10 bg-sand-50 ring-1 ring-ink-900/10">
      {MOCK_REMINDERS.map((item) => (
        <li
          key={item.id}
          className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
        >
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <p className="font-medium text-ink-900">{item.name}</p>
              <span
                className={`px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${
                  item.active
                    ? 'bg-emerald-50 text-emerald-800'
                    : 'bg-ink-900/5 text-ink-600'
                }`}
              >
                {item.active ? 'On' : 'Off'}
              </span>
            </div>
            <p className="mt-1 text-sm text-ink-700/75">{item.trigger}</p>
            <p className="mt-1 text-xs text-ink-600/60">{item.channels.join(' · ')}</p>
          </div>
          <p className="flex-none text-sm text-ink-700/80">
            <span className="font-display text-2xl font-light text-ink-900">
              {item.sentLast7d}
            </span>
            <span className="ml-2 text-xs uppercase tracking-[0.12em] text-ink-600/55">
              sent · 7d
            </span>
          </p>
        </li>
      ))}
    </ul>
  </div>
);

export default MessagesReminders;
